import styled, { CSSObject } from 'styled-components';

interface NavTabPropsStyledProps {
  size?: 'small' | 'default';
  active?: boolean;
  inverse?: boolean;
  semiActive?: boolean;
  activeIconColor?: string;
}

const NavTabStyled = styled.div<NavTabPropsStyledProps>(
  ({ activeIconColor, semiActive, active, inverse, size, theme }) => {
    let styleSheet: CSSObject = {
      border: `2px solid ${theme.color.wfBlack}`,
      width: 40,
      height: 40,
      background: theme.color.wfBlack,
      userSelect: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      'svg path': {
        fill: theme.color.wfWhite,
      },
    };

    if (!active && !inverse && !semiActive) {
      styleSheet = {
        ...styleSheet,
        '&:hover': {
          borderColor: theme.color.wfGrey,
          background: theme.color.wfGrey,
        },
      };
    }

    if (inverse) {
      styleSheet = {
        ...styleSheet,
        background: theme.color.wfWhite,
        'svg path': {
          fill: theme.color.wfBlack,
        },
      };
    }

    if (active) {
      styleSheet = {
        ...styleSheet,
        borderColor: theme.color.wfWhite,
        background: theme.color.wfWhite,
        'svg path': {
          fill: activeIconColor || theme.color.wfBlue,
        },
      };
    }

    if (semiActive) {
      styleSheet = {
        ...styleSheet,
        borderColor: theme.color.wfBlack,
        background: theme.color.wfGrey200,
        'svg path': {
          fill: theme.color.wfBlack,
        },
      };
    }

    if (size === 'small') {
      styleSheet = {
        ...styleSheet,
        width: 32,
        height: 32,
      };
    }

    return styleSheet;
  },
);

export { NavTabStyled };
